/* global axios */
import ApiClient from './ApiClient';

class WhatsappContactPreferencesAPI extends ApiClient {
  constructor() {
    super('whatsapp_contact_preferences', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(contactId, params = {}) {
    return axios.get(`${this.url}/${contactId}`, { params });
  }

  updatePreference(contactId, params) {
    return axios.patch(`${this.url}/${contactId}`, params);
  }

  reviewCandidate(params) {
    return axios.post(`${this.url}/review_candidate`, params);
  }

  backfillPreview(params) {
    return axios.post(`${this.url}/backfill_preview`, params);
  }

  backfillApply(params) {
    return axios.post(`${this.url}/backfill_apply`, params);
  }
}

export default new WhatsappContactPreferencesAPI();
